import React from "react";
import { MAX_TEXT_LENGTH, isTextOverLimit } from "../../utils/textColorUtils";

const ThreadTextCounter = ({ 
  text, 
  maxLength = MAX_TEXT_LENGTH 
}) => {
  const isOverLimit = isTextOverLimit(text, maxLength);
  
  return (
    <div style={{
      fontSize: "12px",
      color: isOverLimit ? "#e03131" : "#8e8e8e",
      marginTop: "4px",
      textAlign: "right"
    }}>
      {text ? text.length : 0}/{maxLength}
    </div>
  );
};

export default ThreadTextCounter; 